import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[restrict-input]'
})
export class RestrictInputDirective implements AfterViewInit {
  @Input('restrict-input') key: string;

  constructor(private el: ElementRef, private control: NgControl) {}

  ngAfterViewInit(): void {
    this.parseValue();
  }

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const initalValue = this.el.nativeElement.value;
    this.parseValue(event as InputEvent);
    if (initalValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    this.el.nativeElement.value === '' && this.control.control?.setValue('');
  }

  private parseValue(event?: InputEvent): void {
    const initalValue = this.el.nativeElement.value;
    switch (this.key) {
      case 'no_empty_space':
        this.el.nativeElement.value = this.noEmptySpace(initalValue);
        break;
      case 'number_only':
        this.el.nativeElement.value = this.noEmptySpace(initalValue).replace(/[^\d]/g, '');
        break;
      case 'date':
        this.el.nativeElement.value = this.noEmptySpace(initalValue).replace(/[^\d\/-]+/g, '');
        break;
      case 'expiry_date':
        if (event?.inputType === 'deleteContentBackward') return;
        this.el.nativeElement.value = this.expiryDate(initalValue);
        break;
      default:
        this.el.nativeElement.value = initalValue;
        break;
    }
  }

  private noEmptySpace(value: string): string {
    return value.trim() == '' ? '' : value;
  }

  private expiryDate(value: string): string {
    return value
      .replace(/^([1-9]\/|[2-9])$/g, '0$1/')
      .replace(/^(0[1-9]|1[0-2])$/g, '$1/')
      .replace(/^([0-1])([3-9])$/g, '0$1/$2')
      .replace(/^(0?[1-9]|1[0-2])([0-9]{2})$/g, '$1/$2')
      .replace(/^([0]+)\/|[0]+$/g, '0')
      .replace(/[^\d\/]|^[\/]*$/g, '')
      .replace(/\/\//g, '/');
  }
}
